var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticStyle:{"direction":"ltr"}},[_c('div',[_vm._v("جار تسجيل الخروج ...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }